angular
    .module('app')
    .component('winbackCampaignsAdd', {
        templateUrl: '/templates/pages/winback-campaigns/winback-campaigns-add/winback-campaigns-add.html',
        controller: 'WinbackCampaignsAddController',
        controllerAs: 'vm',
    });